import styled from "styled-components";

export const StyledTablePage = styled.section`

    .table-legend-info {
        font-size: 12px;
        text-align: center;
        font-weight: 1000;
    }

    .esclarecimentoCard{
        background: #f3e8f3 !important;
    }

    .probonoCard {
        background: #cdeeff;
    }

    .table-data-info {
        font-size: 12px;
        text-align: center;
    }

    .stick-horizontal-header {
    background: #fff;
        position: -webkit-sticky;
        position: sticky;
        z-index: 9999;
        top: 0;
        left: 0;
    }

    .stick-horizontal-body {
    background: #fff;
        position: -webkit-sticky;
        position: sticky;
        left: 0;
        top 95px;
    }

    .greenCell {
        background: #b5e6a2;
        font-size: 14px;
        font-weight: bold;
    }

    .yellowCell {
        background: #ffff99;
        font-size: 14px;
        font-weight: bold;
    }

    .redCell {
        background: #e1b7bb;
        font-size: 14px;
        font-weight: bold;
    }

    .feriasCell {
        background: #F2A057;
        font-size: 14px;
        font-weight: bold;
    }

    .recessoCell {
        background: #CDCCD7;
        font-size: 14px;
        font-weight: bold;
    }

    .preAdmissoesCell {
        background: #CDCCD7;
        font-size: 14px;
        font-weight: bold;
    }

    .font-wip-diario {
        font-size: 14px;
    }

    .table-data-info-warning {
        font-size: 12px;
        text-align: center;
        background-color: #fff3cd;
    }

    .table-data-info-canceled {
        font-size: 12px;
        text-align: center;
        // background-color: #FF7F7F;
    }

    .table-data-info-pro-bono {
        font-size: 12px;
        text-align: center;
        background: #cdeeff;
    }

    .table-width {
        width: 100%;
    }

    .display-none {
        display: none;
    }

    .prazo- {
        display: none;
    }

    .prazo-error {
        color: #dc3545 !important;
    }

    .prazo-warning {
        color: #ffc107 !important;
    }

    .prazo-success {
        color: #28a745 !important;
    }

    table.table-bordered{
        border:1px solid #E8E8E8;
        margin-top:20px;
        border-top-style: none;
        border-left-style: none;
        border-right-style: none;
      }
    table.table-bordered > thead > tr > th {
        border:1px solid #E8E8E8;
        border-top-style: none;
        border-left-style: none;
        border-right-style: none;
        // &:after {
        //     content: '';
        //     position: absolute;
        //     top: -1px;
        //     left: -1px;
        //     right: -1px;
        //     bottom: -1px;
        //     border: 1px solid #E8E8E8;
        // }
    }

    table.table-bordered > tfoot > tr > th {
        border:1px solid #E8E8E8;
        border-top-style: none;
        border-left-style: none;
        border-right-style: none;
        font-size: 13px;

        &:after {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            right: -1px;
            bottom: -1px;
            border: 1px solid #E8E8E8;
        }
    }

    table.table-bordered > tfoot > tr:first-child {
        th:after {
            border-top: 1px solid #000 !important;
        }
    }

    table.table-bordered > tfoot > tr:last-child {
        th:after {
            border-bottom: 1px solid #000 !important;
        }
    }

    table.table-bordered > tbody > tr > td{
        border:1px solid #E8E8E8;
        border-top-style: none;
        border-left-style: none;
        border-right-style: none;
    }

    .table-value {
        font-size: 12px;
        text-align: center;
        font-weight: 1000;
    }

    .table-nowrap {
        white-space: nowrap;
    }


    .table-button {
        font-size: 14px;
        text-align: center;
        font-weight: 1000;
        width: 30% !important;
        color: #E8E8E8;
    }

    .table-color-button {
        color: #EE4B21;
    }

    .size-icon-acoes {
        font-size: 16px;
        cursor: pointer;
    }

    thead > tr > th{
        font-size: 13px;
    }

    .table-scroll {
        overflow-y: hidden;
        width:100%;
        height:100%;
    }

    .primeiro-ativo {
        color: #6c757d;
        font-weight: bold;
    }

    .primeiro-ativo-wip {
        color: #5c6064;
        font-weight: bold;
    }

    .primeiro-reprovado {
        background: #ff626230;
    }

    @media only screen and (max-width: 769px) {
        .card-mobile-table{
            width: 360px;
            overflow: auto;
        }

        .table-scroll {
            overflow-x: scroll;
        }

        .form-container-min {
            width: 100% !important;
        }


    }
    @media only screen and (max-width: 321px) {
        .card-mobile-table{
            width: 320px;
            overflow: auto;
        }
    }

    input {
        padding: 0.5rem 0.3rem;
        border-radius: 0.25rem;
        border: solid 1px #D2D2D2;
      --  width: -webkit-fill-available;
    }

    .outros-ts {
        width: 100%;
    }

    @media only screen and (min-width: 376px) {
        .outros-ts {
            margin-left: 14px;
        }

    }

    @media only screen and (min-width: 770px) {
        .table-scroll {
            overflow-y: scroll;
            overflow-x: scroll !important;
        }

            .table-container {
                width: 100%;
                overflow-y: auto;
                overflow-x: scroll;
                height: 550px;


                table {
                    border-collapse: collapse;
                    width: auto;
                    table-layout: auto;
                }

                th,
                td {
                }

                th {
                    background-color: #fff;
                    position: sticky;
                    top: 0;
                }
              }

    }


    @media only screen and (min-width: 1500px) {

        table {
            border-collapse: collapse;
            width: 100% !important;
            table-layout: auto;
        }

        th{
            // text-align: center;
           // padding-left: 1.5rem;
        }


        .fixed-width-200 {
            width: 200px !important;
            white-space: wrap;
        }


        .fixed-width-390 {
            width: 390px !important;
            white-space: wrap;
        }



        .fixed-width-180 {
            width: 180px !important;
            white-space: wrap;
        }



    }
    .fixed-width-95 {
        width: 95px !important;
        white-space: nowrap !important;
    }

    .text-no-wrap {
        white-space: nowrap;
    }

    .custon-tr-total-lanc{

    td{
        background-color: #fbfbfb;
        border:none;
        font-weight: bold;
            font-size: 13px;
        }
    }


    .total-bg{
        background-color: #f1f1f1;
        font-weight: bold;
    }


    .desconto-ts{
        background-color: #f1f1f1;
        color: red;
    }

    .table-ts-principal-check {
        background-color: #d6d6d6
    }

`;
